import { IonContent, IonInput, IonPage, IonText, IonIcon,IonSpinner } from "@ionic/react";
import { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router";
import DataTable from "react-data-table-component";
import service from "../../../Service/service";
import Head from "../../Header";
import Sidebar from "../../Sidebar";

const EmpEffortdash: React.FC = () => {
    const history = useHistory();

    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);
    const [data, setData]: any = useState([]);
    const [Data, setdata]: any = useState([]);
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");

    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [employeelist, setEmployeelist] = useState([]);

    const [modalopen, setModalopen] = useState(false);
    const [project, setprojectname] = useState('');
    const [activity, setprojectactivity] = useState([]);
    const [effort, seteffort] = useState([]);
    const [status, setstatus] = useState('');
    const [loading,setloading]=useState(false)
    useEffect(() => {
        ProjectDashboard();
    }, []);

    const ProjectDashboard = () => {
        setloading(true)
        setTimeout(() => {
        service.EmpProjectDash(Id)
            .then((response) => {
                console.log(response, "data")
                if (response.status === 200) {
                    setData(response.data);
                    // setprojectname(response.data.project)
                    // setdata(response.data.projectReports)
                    // setstatus(response.data.status)
                }
                else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setloading(false);
            });
    }, 1000); 
    }
    const View = (project: any, activity: any, effort: any, status: any) => {
        ProjectDashboard();
        setModalopen(true);
        setprojectname(project)
        setprojectactivity(activity)
        seteffort(effort)
        setstatus(status)
        console.log("1", project)
        console.log("2", activity)
        console.log("3", effort)
        console.log("4", status)

    }

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            // width: "100px",
        },
        {
            name: "Project",
            selector: (itm: any) => itm.project,
            sortable: true,
            sort: "name",
            //width: "300px",

        },
        // {
        //     name: "Plan Start Date",
        //     selector: (itm: any) => itm.fromDate,
        //     sortable: true,
        //     // width: "200px",
        // },
        {
            name: "Plan Start Date",
            selector: (itm: any) => {
                const dateParts = itm.fromDate.split("-");
                if (dateParts.length === 3) {
                    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                }
                return itm.fromDate;
            },
            sortable: true,
            //width: "200px",
        },
        {
            name: "Plan End Date",
            selector: (itm: any) => {
                const dateParts = itm.toDate.split("-");
                if (dateParts.length === 3) {
                    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                }
                
                return itm.toDate;
            },
            sortable: true,
            //width: "320px",
        },
        // {
        //     name: "Plan End Date",
        //     selector: (itm: any) => itm.toDate,
        //     sortable: true,
        //     //width: "320px",
        // },
        {
            name: "Effort(Hrs)",
            selector: (itm: any) => itm.effort,
            sortable: true,
        },
        {
            name: "Status",
            selector: (itm: any) => itm.status,
            sortable: true,
        },
        {
            name: " Action",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", paddingLeft: "15px" }}>
                        <IonText onClick={() => View(itm.project, itm.projectReports.activity, itm.projectReports, itm.status)} style={{ color: "coral", cursor: 'pointer' }} >View</IonText>
                    </div>
                </>
            )
        },
    ]

    const column: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => (i + 1),
            sortable: false,
            // width: "100px",
        },
        {
            name: "Project Activity",
            selector: (itm: any) => itm.activity,
            sortable: true,
            sort: "name",
            width: "300px",

        },
        {
            name: "Effort",
            selector: (itm: any) => itm.effortTillDate,
            sortable: true,
            // width: "200px",
        },

    ]
    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const table = Data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );


    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };
    const closemodal = () => {
        setModalopen(false);
    }
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);


    const back = () => {
        history.goBack();
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="col">
                            <h3 className="page-title"> <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "2px" }} /> Dashboard </h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item active">My Project Effort</li>
                                </ul>
                            </div>
                            <Modal dialogClassName="modal-dialog modal-lg" show={modalopen}>
                                <div className="modal-header">
                                    <h5 className="modal-title">View My Efforts</h5>
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Name </label>
                                            <div>
                                                <IonInput value={project} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                        {/* <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Activity </label>
                                            <div>
                                                <IonInput value={activity}  className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>My Effort </label>
                                            <div>
                                                <IonInput value={effort} className="form-control datetimepicker" />
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Status </label>
                                            <div>
                                                <IonInput value={status} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                {/* {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )} */}
                                <div style={{ border: '1px solid #ddd' }}>
                                    <div className="table-responsive">
                                        <DataTable
                                            columns={column}
                                            data={effort}
                                            pagination
                                            paginationPerPage={3}
                                            paginationComponentOptions={paginationComponentOptions}
                                            paginationRowsPerPageOptions={[10, 20, 30]}
                                            customStyles={customStyles}
                                        // striped
                                        // highlightOnHover
                                        />
                                    </div>
                                </div>

                            </Modal>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </IonContent>
        </IonPage>
    )
}

export default EmpEffortdash;